'use strict';

function s(){return !!(typeof window<"u"&&window.__ENV)}function t(){let r=process.env.PRECOMPOSER_ENV_PREFIX||"NEXT_PUBLIC";return Object.keys(process.env).filter(n=>new RegExp(`^${r}_`,"i").test(n)).reduce((n,e)=>(n[e]=process.env[e],n),{})}function i(r){let e=`${(s()?window.__ENV.PRECOMPOSER_ENV_PREFIX:process.env.PRECOMPOSER_ENV_PREFIX)||"NEXT_PUBLIC"}_${r}`;return s()?window.__ENV[e]?window.__ENV[e]:"":process.env[e]?process.env[e]:""}

exports.env = i;
exports.envList = t;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map